import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { Popup } from '@progress/kendo-react-popup';
function TimeZoneDropdown(params) {
    var _a;
    const selectedElement = useMemo(() => {
        var _a;
        return (_a = params.timeZoneList) === null || _a === void 0 ? void 0 : _a.find((option) => option.value === params.selectedValue);
    }, [params.timeZoneList, params.selectedValue]);
    const anchor = useRef(null);
    const popup = useRef(null);
    const [show, setShow] = useState(false);
    const handleItemClick = (element) => {
        params.onChange(element.value);
        setShow(false);
    };
    const handleBodyClick = useCallback((e) => {
        var _a, _b;
        if (popup.current && ((_a = popup.current._popup) === null || _a === void 0 ? void 0 : _a.contains(e.target)))
            return;
        if (anchor.current && ((_b = anchor.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)))
            return;
        setShow(false);
    }, []);
    useEffect(() => {
        document.body.addEventListener('click', handleBodyClick);
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "qmb-control--menu", ref: anchor, style: { fontSize: '14px', fontWeight: 500, minHeight: '32px', lineHeight: '24px', borderRadius: '4px' }, type: "button", onClick: () => setShow(!show) },
            React.createElement("i", { className: "fa-light fa-clock-five" }),
            " ", selectedElement === null || selectedElement === void 0 ? void 0 :
            selectedElement.label),
        React.createElement(Popup, { anchor: anchor.current, show: show, ref: popup, anchorAlign: { horizontal: 'right', vertical: 'bottom' }, popupAlign: { horizontal: 'right', vertical: 'top' } },
            React.createElement("div", { className: "qmb-popup--action-list", style: { maxWidth: 'none', maxHeight: '40rem', overflowY: 'scroll' } },
                React.createElement("div", { className: "popup__section" },
                    React.createElement("ul", { role: "presentation" }, (_a = params.timeZoneList) === null || _a === void 0 ? void 0 : _a.map((timeZone) => (React.createElement("li", { key: timeZone.value },
                        React.createElement("button", { type: "button", onClick: () => handleItemClick(timeZone), style: { fontSize: '14px', fontWeight: 500, lineHeight: '24px' } }, timeZone.label))))))))));
}
export default TimeZoneDropdown;
